import React, { useState } from "react";
import { IMaster } from "app/api/types";
import EditMasterForm from "app/components/EditMasterForm";

import "./styles.scss";

interface IProps {
  master: IMaster;
  onSubmit: (data: IMaster) => void;
  onDelete: (email: IMaster["email"]) => void;
}

const Group: React.FC<IProps> = (props) => {
  const [isCollapsed, setCollapse] = useState(true);
  const [isDeleting, setDelete] = useState(false);

  const triggerCollapse = () => {
    setCollapse(!isCollapsed);
  };

  const onDelete = () => {
    setDelete(true);
    props.onDelete(props.master.email);
  };

  const styles = {
    minHeight: !isCollapsed ? "1140px" : "60px",
  };

  return (
    <div
      className={`phrase-container ${isDeleting ? "deleting" : ""}`}
      style={styles}
    >
      <div className="phrase-wrapper">
        <div className="left-block" onClick={triggerCollapse}>
          <div className="phrase-text">{props.master.name}</div>
          <div className="phrase-translation">{props.master.position}</div>
        </div>

        <div className="right-block">
          <p className="phrase-del" onClick={onDelete}>
            удалить
          </p>
        </div>
      </div>

      <EditMasterForm
        master={props.master}
        onSubmit={props.onSubmit}
        isActive={!isCollapsed}
      />
    </div>
  );
};

export default Group;
